// SupabaseLeaderboard: cross-player leaderboards backed by Postgres.
// submit() inserts a score under the shared player identity; top() calls the
// leaderboard_top() SQL function (best-score-per-player, ranked).
// Requires the `scores` table + leaderboard_top() function from SUPABASE_SETUP.md.

export class SupabaseLeaderboard {
  constructor(backend) {
    this.backend = backend;
  }

  _c() {
    if (!this.backend?.ready || !this.backend.client) {
      throw new Error('Supabase backend not ready.');
    }
    return this.backend.client;
  }

  async submit(boardId, { name, score, meta }) {
    const display = name || this.backend.identity.displayName;
    const { error } = await this._c().from('scores').insert({
      player_id: this.backend.identity.playerId,
      board_id: boardId,
      display_name: String(display).slice(0, 32),
      score: Number(score) || 0,
      meta: meta ?? null,
    });
    if (error) throw error;

    // Fetch the player's current rank for this board.
    const { data } = await this._c().rpc('leaderboard_top', {
      p_board_id: boardId,
      p_limit: 1000,
    });
    const me = (data || []).find((r) => r.player_id === this.backend.identity.playerId);
    return { ok: true, rank: me ? Number(me.rank) : null };
  }

  async top(boardId, limit = 10) {
    const { data, error } = await this._c().rpc('leaderboard_top', {
      p_board_id: boardId,
      p_limit: limit,
    });
    if (error) throw error;
    return (data || []).map((r) => ({
      rank: Number(r.rank),
      name: r.display_name,
      score: Number(r.score),
      meta: r.meta,
      isMe: r.player_id === this.backend.identity.playerId,
    }));
  }
}
